<div class="confirmed-block">
  <h2>{{ 'games.planning.confirmed_matches' | translate }}</h2>

  <div [nbSpinner]="loadingConfirmedMatch"
       nbSpinnerStatus="danger"
       nbSpinnerSize="large"
       nbSpinnerMessage="">
    @if(confirmedMatches().length > 0) {
      @for (match of confirmedMatches(); track match.match_id) {
        <div class="games-card match-card">
          <div class="match-team-1" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_1)">{{ match.team_1_name }}</div>
          <div class="match-details">
            <div class="match-date">{{ match.scheduled_start_time | date: 'dd-MM-yyyy HH:mm' }}</div>
            <div class="match-author ml-5"><nb-icon icon="person-add-outline" nbTooltip="Submitted by {{ match.author }}" /></div>
            <div class="cast">{{ 'games.planning.cast' | translate }}: {{ match.cast ? ('common.yes_short' | translate) : ('common.no_short' | translate) }}</div>
            <div class="tag-container"><span class="tag confirmed">{{ 'games.planning.confirmed_tag' | translate }}</span></div>
          </div>
          <div class="match-team-2" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_2)">vs {{ match.team_2_name }}</div>
        </div>
      }
    }
    @else {
      <div class="no-data">{{ 'games.planning.no_confirmed_match' | translate }}</div>
    }
  </div>
</div>

<div class="pending-block">
  <h2>{{ 'games.planning.pending' | translate }}</h2>

  <div [nbSpinner]="loadingPendingMatch"
       nbSpinnerStatus="danger"
       nbSpinnerSize="large"
       nbSpinnerMessage="">
    @if(pendingMatches().length > 0) {
      @for (match of pendingMatches(); track match.match_id) {
        <div class="games-card match-card">
          <div class="match-team-1" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_1)">{{ match.team_1_name }}</div>
          <div class="match-details">
            <div class="match-date">{{ match.opponent_new_date || match.scheduled_start_time | date: 'dd-MM-yyyy HH:mm' }}</div>
            <div class="match-author ml-5"><nb-icon icon="person-add-outline" nbTooltip="Submitted by {{ match.author }}" /></div>
            <div class="tag-container">
              @if(match.opponent_new_date) {
                <span class="tag opponent-new-date">{{ 'games.planning.new_date_proposed_tag' | translate }}</span>
              }
              @else {
                <span class="tag pending">{{ 'games.planning.waiting_opponent_tag' | translate }}</span>
              }
            </div>
          </div>
          <div class="match-team-2" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_2)">vs {{ match.team_2_name }}</div>
          <div class="pending-matches-buttons">
            @if (!match.opponent_new_date) {
              <button nbButton status="basic" (click)="editPendingMatch(match)">{{ 'games.planning.propose_new_date' | translate }}</button>
              <button nbButton status="danger" (click)="openConfirmCancel(match)">{{ 'games.planning.cancel_btn' | translate }}</button>
            } @else {
              <button nbButton status="primary" (click)="openConfirmAccept(match)">{{ 'games.planning.accept_btn' | translate }}</button>
              <button nbButton outline status="primary" (click)="openConfirmDecline(match)">{{ 'games.planning.decline_btn' | translate }}</button>
            }
          </div>
        </div>
      }
    }
    @else {
      <div class="no-data">{{ 'games.planning.no_pending_match' | translate }}</div>
    }
  </div>
</div>

<div class="proposed-block">
  <h2>{{ 'games.planning.proposed_matches' | translate }}</h2>

  <div [nbSpinner]="loadingProposedMatch"
       nbSpinnerStatus="danger"
       nbSpinnerSize="large"
       nbSpinnerMessage="">
    @if(proposedMatches().length > 0) {
      @for (match of proposedMatches(); track match.match_id) {
        <div class="games-card match-card">
          <div class="match-team-1" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_1)">{{ match.team_1_name }}</div>
          <div class="match-details">
            <div class="match-date">{{ match.opponent_new_date || match.scheduled_start_time | date: 'dd-MM-yyyy HH:mm' }}</div>
            <div class="match-author ml-5"><nb-icon icon="person-add-outline" nbTooltip="Submitted by {{ match.author }}" /></div>
            <div class="cast">{{ 'games.planning.cast' | translate }}: {{ match.cast ? ('common.yes_short' | translate) : ('common.no_short' | translate) }}</div>
          </div>
          <div class="match-team-2" [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_2)">vs {{ match.team_2_name }}</div>
          <div class="proposed-matches-buttons">
            @if (!match.opponent_new_date) {
              <button nbButton status="primary" (click)="openConfirmAccept(match)">{{ 'games.planning.accept_btn' | translate }}</button>
              <button nbButton outline status="primary" (click)="openConfirmDecline(match)">{{ 'games.planning.decline_btn' | translate }}</button>
              <button nbButton outline status="basic" (click)="openProposeNewTimeForm(match)">{{ 'games.planning.propose_new_date' | translate }}</button>
            }
          </div>
        </div>
      }
    }
    @else {
      <div class="no-data">{{ 'games.planning.no_proposed_match' | translate }}</div>
    }
  </div>
</div>
